import React, { useEffect, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import SubNav from './SubNav';
import Tabs from './Tabs';
import AnonMenu from './AnonMenu/AnonMenu';
// import './TopNav.less';
import Hamburger from './Hamburger';
import { useRouter } from 'next/router';
import { Logo, LogoBrand, useGlobalToggle, Button } from 'edcom-ui';
import AccountContext from '../../services/AccountContext';
import dynamic from 'next/dynamic';
import BannerNotifications from './BannerNotifications/BannerNotifications';
import styles from './TopNav.module.less';
import clsx from 'clsx';
import BrainzyAccess from './BrainzyAccess';

// Code split this into a separate chunk
const UserMenu = dynamic(() => import('./MemberMenu/UserMenu'), { ssr: false });

export default function TopNav({ page, withSubNav = true }) {
  //Determine if user is a member or not after AccountContext returns user object
  const { email, ready, isPremium, isSchoolAdmin } = useContext(AccountContext);
  const isMember = email != null;
  useEffect(() => {}, [email]);

  const menuRef = useRef(null);
  const [expanded, setExpanded] = useGlobalToggle(menuRef);
  const subMenuRef = useRef(null);
  const [subMenuExpanded, setSubMenuExpanded] = useGlobalToggle(subMenuRef);

  const router = useRouter();

  // Hide hamburger menu when navigation occurs
  useEffect(() => {
    const callback = () => {
      setExpanded(false);
    };

    router.events.on('routeChangeStart', callback);
    return () => {
      router.events.off('routeChangeStart', callback);
    };
  }, []);

  const handleHamburgerExpand = () => {
    setExpanded(!expanded);
  };

  const handleSubMenuExpand = () => {
    setSubMenuExpanded(!subMenuExpanded);
  };

  return (
    <>
      {/* todo: my accounts modal, probably move to Login component */}
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.navLinks} ref={menuRef}>
            <div
              className={clsx(
                styles.logoWrapper,
                expanded && styles.open,
                !isMember && styles.anonUser
              )}
            >
              <Hamburger
                open={expanded}
                onClick={handleHamburgerExpand}
                mobileOnly={true}
              />
              <a
                href="/"
                title="Education.com Home Page"
                aria-label="logo"
                tabIndex="0"
                className={styles.logoLink}
              >
                <Logo className={styles.logo} />
                <LogoBrand className={styles.logoBrand} />
              </a>
            </div>
            <Tabs open={expanded} page={page} />
          </div>
          {ready && isMember && <BrainzyAccess isMobile={false} />}
          {(ready || isMember) && (
            <motion.div
              className={styles.userLinks}
              initial={{ opacity: 0, scale: 0.85 }}
              animate={{ opacity: 1, scale: 1 }}
            >
              {isMember && !isPremium && !isSchoolAdmin && (
                <div className={styles.upgradeLink}>
                  <Button
                    href={'/pricing/'}
                    color={'teal'}
                    className={styles.tryPremium}
                  >
                    Try Premium
                  </Button>
                </div>
              )}
              {isMember ? (
                <UserMenu hamburgerOpen={expanded} />
              ) : (
                <AnonMenu hamburgerOpen={expanded} />
              )}
            </motion.div>
          )}
          {/* todo: add student access modal */}
        </div>
      </header>
      {page !== 'search' && withSubNav && (
        <SubNav
          open={subMenuExpanded}
          onClick={handleSubMenuExpand}
          page={page}
          ref={subMenuRef}
        />
      )}
      <BannerNotifications />
    </>
  );
}

TopNav.propTypes = {
  page: PropTypes.string,
  withSubNav: PropTypes.bool,
};
